"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderPhotoUploaderField = exports.renderMultiImagesFieldWithMainImage = exports.renderMultiImagesField = exports.renderMultiFilesFieldWithDescription = exports.renderMultiFilesFieldNew = exports.renderMultiFilesField = exports.renderFileUploaderField = void 0;
var _react = _interopRequireDefault(require("react"));
var _PhotoUploader = _interopRequireDefault(require("./PhotoUploader"));
var _MultiImageUploder = _interopRequireDefault(require("./MultiImageUploder"));
var _FileUploader = _interopRequireDefault(require("./FileUploader"));
var _MultiFileUploader = _interopRequireDefault(require("./MultiFileUploader"));
var _MultiFileUploaderWithDescription = _interopRequireDefault(require("./MultiFileUploaderWithDescription"));
var _MultiImageUploderWithMainImage = _interopRequireDefault(require("./MultiImageUploderWithMainImage"));
var _MultiFileUploaderAdvanced = require("./MultiFileUploaderAdvanced");
var _excluded = ["field", "form"],
  _excluded2 = ["field", "form"],
  _excluded3 = ["field", "form"],
  _excluded4 = ["field", "form"],
  _excluded5 = ["field", "form"],
  _excluded6 = ["field", "form"],
  _excluded7 = ["field", "form"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var renderPhotoUploaderField = function renderPhotoUploaderField(_ref) {
  var field = _ref.field,
    form = _ref.form,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PhotoUploader.default, _extends({}, field, form, rest));
};
exports.renderPhotoUploaderField = renderPhotoUploaderField;
var renderMultiImagesField = function renderMultiImagesField(_ref2) {
  var field = _ref2.field,
    form = _ref2.form,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_MultiImageUploder.default, _extends({}, field, form, rest));
};
exports.renderMultiImagesField = renderMultiImagesField;
var renderMultiImagesFieldWithMainImage = function renderMultiImagesFieldWithMainImage(_ref3) {
  var field = _ref3.field,
    form = _ref3.form,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_MultiImageUploderWithMainImage.default, _extends({
    field: field,
    form: form
  }, rest));
};
exports.renderMultiImagesFieldWithMainImage = renderMultiImagesFieldWithMainImage;
var renderFileUploaderField = function renderFileUploaderField(_ref4) {
  var field = _ref4.field,
    form = _ref4.form,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement(_FileUploader.default, _extends({}, field, form, rest));
};
exports.renderFileUploaderField = renderFileUploaderField;
var renderMultiFilesField = function renderMultiFilesField(_ref5) {
  var field = _ref5.field,
    form = _ref5.form,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react.default.createElement(_MultiFileUploader.default, _extends({}, field, form, rest));
};
exports.renderMultiFilesField = renderMultiFilesField;
var renderMultiFilesFieldNew = function renderMultiFilesFieldNew(_ref6) {
  var field = _ref6.field,
    form = _ref6.form,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react.default.createElement(_MultiFileUploaderAdvanced.AdvancedFileUpload, _extends({
    field: field,
    form: form
  }, rest));
};
exports.renderMultiFilesFieldNew = renderMultiFilesFieldNew;
var renderMultiFilesFieldWithDescription = function renderMultiFilesFieldWithDescription(_ref7) {
  var field = _ref7.field,
    form = _ref7.form,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_react.default.createElement(_MultiFileUploaderWithDescription.default, _extends({}, field, form, rest));
};
exports.renderMultiFilesFieldWithDescription = renderMultiFilesFieldWithDescription;